var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_355)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 430,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip1_473_355)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.18,
    cy: 352.18,
    r: 1.18002,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.367,
    cy: 243.367,
    r: 1.3666,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.227,
    cy: 220.227,
    r: 1.22655,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.736,
    cy: 213.736,
    r: 0.736091,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.901,
    cy: 235.901,
    r: 0.900822,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.518,
    cy: 206.518,
    r: 0.517694,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.537,
    cy: 43.537,
    r: 0.536959,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.384,
    cy: 150.384,
    r: 1.3838,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.861,
    cy: 429.861,
    r: 0.861338,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.967,
    cy: 401.967,
    r: 0.966669,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7497,
    cy: 253.75,
    r: 0.749702,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.903,
    cy: 174.903,
    r: 0.902552,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.124,
    cy: 255.124,
    r: 1.12358,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.321,
    cy: 185.321,
    r: 1.32055,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4284,
    cy: 249.428,
    r: 1.42839,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.6457,
    cy: 383.646,
    r: 0.645714,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.086,
    cy: 418.086,
    r: 1.08567,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.618,
    cy: 332.618,
    r: 0.617733,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.503,
    cy: 389.503,
    r: 0.50342,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.539,
    cy: 262.539,
    r: 0.538745,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.525,
    cy: 133.525,
    r: 0.524912,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.732,
    cy: 5.73204,
    r: 0.732036,
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.462,
    cy: 325.462,
    r: 1.46153,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.244,
    cy: 424.244,
    r: 1.24448,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.959,
    cy: 107.959,
    r: 0.959039,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.541,
    cy: 413.541,
    r: 0.541051,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.733,
    cy: 13.7326,
    r: 0.73259,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.508,
    cy: 155.508,
    r: 0.508167,
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.428,
    cy: 352.428,
    r: 1.42787,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.43,
    cy: 180.43,
    r: 1.43038,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 70.4999,
    r: 1.49994,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.276,
    cy: 352.276,
    r: 1.27559,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.528,
    cy: 402.528,
    r: 0.527992,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.4377,
    cy: 132.438,
    r: 1.43768,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.251,
    cy: 26.2514,
    r: 1.25141,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.831,
    cy: 265.831,
    r: 0.831381,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.19,
    cy: 173.19,
    r: 1.18981,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.9122,
    cy: 8.91224,
    r: 0.912243,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.88,
    cy: 411.88,
    r: 0.880399,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.515,
    cy: 134.515,
    r: 0.514949,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.914,
    cy: 391.914,
    r: 0.914186,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.212,
    cy: 186.212,
    r: 1.21235,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.905,
    cy: 250.905,
    r: 0.904641,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.844,
    cy: 118.844,
    r: 0.844371,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.933,
    cy: 221.933,
    r: 0.932846,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.023,
    cy: 176.023,
    r: 1.02265,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.921,
    cy: 115.921,
    r: 0.920972,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.4952,
    cy: 181.495,
    r: 1.49518,
    fill: "white",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_473_355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328 222.375C328 193.2 280.981 244.233 257.331 222.375C233.68 200.517 201.065 186.478 165.628 182.902C130.19 179.326 94.3749 186.459 64.9265 202.959C64.9265 202.959 -38.4189 208.503 -47.1065 236.802C-55.7941 265.101 1.32698 330.702 17.758 356.605C34.189 382.507 -71.0813 449.881 94.9512 413.123C128.259 423.636 179.644 515.367 213.12 505.217C246.597 495.068 259.856 383.739 276.709 358.018L189.146 308.676L328 222.375Z",
    fill: "#3598DB",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_473_355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633 40.3755C633 11.2 585.981 62.2335 562.331 40.3755C538.68 18.5175 506.065 4.47824 470.628 0.902005C435.19 -2.67423 399.375 4.45914 369.927 20.9586C369.927 20.9586 266.581 26.5032 257.894 54.8019C249.206 83.1006 306.327 148.702 322.758 174.605C339.189 200.507 233.919 267.881 399.951 231.123C433.259 241.636 484.644 333.367 518.12 323.217C551.597 313.068 564.856 201.739 581.709 176.018L494.146 126.676L633 40.3755Z",
    fill: "#3598DB",
    fillOpacity: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_473_355",
    x: -248,
    y: -18,
    width: 776,
    height: 724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_473_355"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_473_355",
    x: 57,
    y: -200,
    width: 776,
    height: 724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_473_355"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 430,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_473_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 430,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.d68d350e55424a273de5490f8a4bb066.svg";
export { ForwardRef as ReactComponent };